var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26120-2",
    "data-name": "Path 26120-2",
    className: "cls-1",
    d: "M59.26,0H4.72A4.68,4.68,0,0,0,0,4.62V59.38A4.68,4.68,0,0,0,4.72,64H59.26A4.69,4.69,0,0,0,64,59.38V4.62A4.69,4.69,0,0,0,59.26,0ZM19,54.53H9.49V24H19Zm-4.74-34.7a5.51,5.51,0,0,1-5.51-5.5h0a5.51,5.51,0,0,1,5.5-5.51h0a5.51,5.51,0,0,1,5.51,5.5h0a5.5,5.5,0,0,1-5.5,5.5Zm40.29,34.7H45.06V39.68c0-3.54-.06-8.1-4.93-8.1s-5.7,3.86-5.7,7.85V54.54H25V24h9.1v4.17h.13a10,10,0,0,1,9-4.93c9.62,0,11.39,6.33,11.39,14.54Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6ae6180af1f0bc681d59edb5ee4808d0.svg";
export { ForwardRef as ReactComponent };